export class ProductSupplierDto {
  sku: string;
  upc: string;
  description: string;
  id?: string;

  constructor(d?: ProductSupplierDto) {
    if (!d) {
      return;
    }

    Object.assign(this, d);
  }
}
